// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f7697a69","113":"949cafab","326":"b301a920","982":"45e9144f"}[chunkId] + ".chunk.js";
};